import { controls } from "../../controls";
const rprbi11 = {
  label: "Education Loan",
  starting: true,
  url: "Education Loan",
  pageLabel: "Education Loan",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.magicDateLabel({ tab: "filter", label: "From Date", width: "col-sm-2", target: "from_date" }),
    ...controls.magicDate({ tab: "filter", name: "from_date", width: "col-sm-2", dateType: "ontype", default: "sd" }),

    ...controls.magicDateLabel({ tab: "filter", label: "As on Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", default: "sd" }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "RBI Education Loan",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },

    textReportProps: {
      'LBS': {
        filename: `RBI-EducationLoan-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    displayColumns: [
      {
        Header: "State Code",
        accessor: "state_code_RBI",
      },
      {
        Header: "District Code",
        accessor: "district_code_RBI",
      },
      {
        Header: "Block Code",
        accessor: "block_code",
      },
      {
        Header: "Sanctioned during year",
        accessor: "sanctioned",
      },
      {
        Header: "No. of Girl Student",
        accessor: "girl",
      },
      {
        Header: "Disbursed during year",
        accessor: "disbursed",
      },
      {
        Header: "Disbursement of Girl",
        accessor: "girl_disbursed",
      },
      {
        Header: "Loan Outstanding",
        accessor: "outstanding",
      },
      {
        Header: "Girl Outstanding",
        accessor: "girl_outstanding",
      },
    ]
  }
};
export default rprbi11;